import React from 'react';
import { Stagger, Item } from './motion';

const principles = [
  {
    title: 'Nimic fără sursă',
    text: 'Orice răspuns, termen sau dată extrasă vine cu trimiterea la actul normativ, la dosarul de pe portal sau la documentul original. Verifici, nu crezi pe cuvânt.',
  },
  {
    title: 'Datele rămân în UE',
    text: 'Documentele și dosarele clienților sunt procesate pe infrastructură din Uniunea Europeană, cu izolare pe organizație și acces pe roluri.',
  },
  {
    title: 'Construit cu practicieni',
    text: 'Fiecare funcționalitate pornește dintr-o discuție cu oameni care lucrează dosare în fiecare zi și se testează pe cazuri reale înainte să ajungă la toți.',
  },
  {
    title: 'Mereu la zi',
    text: 'Legislația se actualizează din Monitorul Oficial, iar dosarele se verifică automat pe portal.just.ro. Nu trebuie să ții tu minte ce s-a schimbat.',
  },
  {
    title: 'Fără capcane',
    text: 'Documentele se exportă în DOCX și PDF, datele sunt ale tale, iar prețul e transparent — abonament acolo unde are sens, credite acolo unde plătești pe volum.',
  },
  {
    title: 'Aplicații care se leagă',
    text: 'Produsele comunică între ele: o sentință procesată într-una aduce termenele în calendarul celeilalte, iar documentele expediate își iau singure numărul de ieșire.',
  },
];

export const Principles = () => (
  <section id="principii" className="section section-warm">
    <div className="container">
      <Stagger>
        <Item as="h2" className="hm-h2">Cum lucrăm.</Item>
        <Item as="p" className="hm-sub">
          Regulile astea explică de ce produsele arată așa cum arată — și ce poți să ne ceri dacă
          vreodată nu se potrivesc.
        </Item>
      </Stagger>

      <Stagger className="vl-list" dense>
        {principles.map((p) => (
          <Item key={p.title} className="vl-item">
            <h3 className="vl-h">{p.title}</h3>
            <p className="vl-p">{p.text}</p>
          </Item>
        ))}
      </Stagger>
    </div>
  </section>
);

export default Principles;
